// ─────────────────────────────────────────────────────────────────────────────
// File: components/weather/utils.js
// ─────────────────────────────────────────────────────────────────────────────
export const PARIS_TZ = 'Europe/Paris';

export function median(values) {
  const arr = (values || []).filter(Number.isFinite).sort((a, b) => a - b);
  if (!arr.length) return null;
  const mid = Math.floor(arr.length / 2);
  return arr.length % 2 ? arr[mid] : (arr[mid - 1] + arr[mid]) / 2;
}

export function collectSources(obj) {
  return obj ? Object.values(obj).filter(Number.isFinite) : [];
}

export function isoToLocalParts(iso, timeZone = PARIS_TZ) {
  const d = new Date(iso);
  const fmt = new Intl.DateTimeFormat('fr-FR', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  const parts = Object.fromEntries(fmt.formatToParts(d).map((p) => [p.type, p.value]));
  return { localDate: `${parts.year}-${parts.month}-${parts.day}`, localTime: `${parts.hour}:${parts.minute}` };
}

export function normalizeHourly(hours) {
  const out = [];
  for (const h of hours || []) {
    const waveHeight_m = median(collectSources(h.waveHeight));
    const swellHeight_m = median(collectSources(h.swellHeight));
    const swellPeriod_s = median(collectSources(h.swellPeriod));
    const windSpeed_ms = median(collectSources(h.windSpeed));
    const windDir_deg = median(collectSources(h.windDirection));
    const { localDate, localTime } = isoToLocalParts(h.time);

    out.push({
      timeISO: h.time,
      localDate,
      localTime,
      waveHeight_m,
      swellHeight_m,
      swellPeriod_s,
      windSpeed_ms,
      windDir_deg,
    });
  }
  const byDate = out.reduce((acc, row) => {
    if (!acc[row.localDate]) acc[row.localDate] = [];
    acc[row.localDate].push(row);
    return acc;
  }, {});
  return { list: out, byDate };
}

export function msToKnots(ms) { return Number.isFinite(ms) ? ms * 1.94384 : null; }
export function formatNum(n, digits = 2) { return Number.isFinite(n) ? n.toFixed(digits) : '—'; }






